import React, { useState, useEffect } from 'react';
import MixedChart from "./MixedChart";
import ClipLoader from 'react-spinners/ClipLoader';

function TrafficByRegion({setloading11, year}){
    const [chart4Data, setchart4Data] = useState(null);
    const [chart4DataOptions, setchart4Options] = useState({});
    
    const [excelDataChart7,setexcelDataChart7] = useState();
  
    useEffect(() => {
  
      var url = "api/cargo_post_by_region/" + year;
      fetch(url).then((res) =>
        res.json().then((res) => {
          console.log(res.data.response)

          // const OriginGoodsList = res.data.response["Εμπορεύματα Προέλευσης"]
          // const DestinationGoodsList = res.data.response["Εμπορεύματα Προορισμού"]
          // const OriginPostOfficeList = res.data.response["Ταχυδρομείο Προέλευσης"]
          // const DestinationPostOfficeList = res.data.response["Ταχυδρομείο Προορισμού"]
          
          // console.log(DestinationGoodsList[0]);

          // for (const obj of OriginGoodsList) {
          //   obj["Είδος"] = year;
          // }
          
          
          // console.log(OriginGoodsList)
          // for (const obj of DestinationGoodsList) {
          //   obj["Είδος"] = "Εμπορεύματα Προορισμού";
          // }

          // for (const obj of OriginPostOfficeList) {
          //   obj["Είδος"] = "Ταχυδρομείο Προέλευσης";
          // }
          
          // for (const obj of DestinationPostOfficeList) {
          //   obj["Είδος"] = "Ταχυδρομείο Προορισμού";
          // }



          // const FinList = [...OriginGoodsList, ...DestinationGoodsList, ...OriginPostOfficeList, ...DestinationPostOfficeList];
          // console.log(FinList)

  
          // setexcelDataChart7(OriginGoodsList);

          let listOfIds = Object.keys(res.data.response["Εμπορεύματα Προέλευσης"])
          
          let data1 = Object.values(res.data.response["Εμπορεύματα Προέλευσης"])
          let data2 = Object.values(res.data.response["Εμπορεύματα Προορισμού"])
          let data3 = Object.values(res.data.response["Ταχυδρομείο Προέλευσης"])
          let data4 = Object.values(res.data.response["Ταχυδρομείο Προορισμού"])

          

          
          let excel_data1 = [];
          let excel_data2 = [];
          let excel_data3 = [];
          let excel_data4 = [];
          listOfIds.forEach((region, i) => {
            excel_data1.push({"Περιφέρεια": region, "Είδος": "Εμπορεύματα Προέλευσης","Τιμή": data1[i]})
            excel_data1.push({"Περιφέρεια": region, "Είδος": "Εμπορεύματα Προορισμού","Τιμή": data2[i]})
            excel_data1.push({"Περιφέρεια": region, "Είδος": "Ταχυδρομείο Προέλευσης","Τιμή": data3[i]})
            excel_data1.push({"Περιφέρεια": region, "Είδος": "Ταχυδρομείο Προορισμού","Τιμή": data4[i]})
          })

          let fin_excel = excel_data1.concat(excel_data2, excel_data3, excel_data4);
          console.log(fin_excel)
          setexcelDataChart7(fin_excel);

          
  
          setchart4Data({
              labels : listOfIds,
              datasets: [
                {
                  type: 'bar',
                  label: 'Εμπορεύματα προέλευσης',
                  data: data1,
                  backgroundColor: '#012D81',
                  barPercentage: 0.8,
                  categoryPercentage: 0.5,
          
                },
                {
                  type: 'bar',
                  label: 'Εμπορεύματα προορισμού',
                  data: data2,
                  backgroundColor: "#0F8DD6",
                  barPercentage: 0.8,
                  categoryPercentage: 0.5,
                },
                {
                  type: 'line',
                  label: 'Ταχυδρομείο προέλευσης',
                  data: data3,
                  backgroundColor: '#FEAB7A',
                  barPercentage: 0.8,
                  categoryPercentage: 0.5,
          
                },
                {
                  type: 'line',
                  label: 'Ταχυδρομείο προορισμού',
                  data: data4,
                  backgroundColor: '#FF9B91',
                  barPercentage: 0.8,
                  categoryPercentage: 0.5,
          
                },    
              ]
            }
          )
  
          setchart4Options({
            maintainAspectRatio: false,
            responsive: true,
            plugins: {
              legend: {
                position: 'bottom',
              },
            }
          })

          setloading11(false)

        })
      )
      .catch((error) => {
        console.log("Refetching data for Mixed Chart!")
      })
  
    }, [year, setloading11]);
  


    return(
      chart4Data ? 
        <MixedChart chartData={chart4Data} chartOptions = {chart4DataOptions} excelData = {excelDataChart7}> </MixedChart>
      :  <ClipLoader size={100} color={'#123abc'} loading={true}/>
        
       
    )
}




export default TrafficByRegion;